import $ from 'jquery';

$(() => {
    $('.custom-file-input').on('change', function (e) {
        /**
         * @type {FileList}
         */
        let files = e.target.files;

        /**
         * @type {string[]}
         */
        let filenames = [];

        if (files.length > 0) {
            $(this).removeClass('is-invalid');
            $(this).siblings('.invalid-feedback').remove();
        }

        for (let i = 0; i < files.length; i++) {
            filenames.push(files[i].name);

            if (files[i].size >= 5 * 1024 ** 2) {
                $(this).addClass('is-invalid');
                $(this).after(`<span class="invalid-feedback" role="alert">
                    Το αρχείο ${files[i].name} δεν πρέπει να ξεπερνάει τα 5MB.
                </span>`);

                this.value = "";

                return false;
            }
        }

        let $label = $(this).siblings('.custom-file-label');
        let $filenames = $(this).parent().siblings('.custom-file-filenames');

        if ($label.data('default-title') === undefined) {
            $label.data('default-title', $label.html());
        }

        $filenames.html(() => {
            return filenames.map((filename) => {
                return `<li class="list-group-item d-flex align-items-baseline">
                    <i class="far fa-file text-muted mr-2" aria-hidden="true"></i>
                    <span class="text-truncate">${filename}</span>
                </li>`;
            });
        });

        $label.html(() => {
            switch (files.length) {
                case 0:
                    return $label.data('default-title');
                case 1:
                    return '1 επιλεγμένο αρχείο';
                default:
                    return `${files.length} επιλεγμένα αρχεία`;
            }
        });
    });
});
